import React from "react";
// import ReactDOM from "react-dom";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
//
import ReactRouterScrollToTop from "./ReactRouter_scrollToTop";

//
import CustomCursor from "./components/cursor/CustomCursor";
import ScrollToTop from "./components/scrollToTop/ScrollToTop";
//
import Navbar from "./components/navigation/Navbar";
import Home from "./components/home/Home";

//// pages
import About from "./components/about/About";
import LetheCity from "./components/letheCityWatersOfOblivion/LetheCity";
import CityOrganic from "./components/cityOrganic/CityOrganic";
import Simurgh from "./components/head_Simurgh/Simurgh";
//
import Portfolio from "./components/portfolio/Portfolio";
import Process from "./components/process/Process";
import Drawings from "./components/drawings/Drawings.js";
import Furniture from "./components/furniture/Furniture";
// footer
import Contact from "./components/contact/Contact";
import Faq from "./components/contact/Faq";

//
// the white page in the framer animation, was due to the USEEFFECT
// add the useffect funtion to the animation, below the const
//
function App() {
  //
  //

  return (
    <Router>
      <ReactRouterScrollToTop />
      <div className="page">
        <CustomCursor />
        <Navbar />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/about" exact component={About} />
          <Route path="/letheCity" exact component={LetheCity} />
          <Route path="/cityOrganic" exact component={CityOrganic} />
          <Route path="/simurgh" exact component={Simurgh} />
          <Route path="/furniture" exact component={Furniture} />
          <Route path="/portfolio" exact component={Portfolio} />
          <Route path="/drawings" exact component={Drawings} />
          <Route path="/process" exact component={Process} />
          <Route path="/faq" exact component={Faq} />
          <Route path="/*" component={Home} />
        </Switch>
        <ScrollToTop />
        <Contact />
      </div>
    </Router>
  );
}

export default App;

// lazy/locootive scroll:  https://www.npmjs.com/package/locomotive-scroll?activeTab=versions
